import { useCallback } from 'react';

export const useDialogFormReset = (onClose: () => void, resetForm: () => void) =>
  useCallback(() => {
    resetForm();
    onClose();
  }, [onClose, resetForm]);
